import React, { CSSProperties, ReactNode, isValidElement } from 'react'
import { Grid, Icon, GlowHeading, Typography, Wrapper } from '~ui'
import { IconTypes, IconOptions } from '~ui/Icon'

import styles from './tickets.module.scss'

interface TicketsProps {
  backgroundImage?: string // format: url(https://)
  title?: string
  color?: GThemeColorsNew
  icon?: IconTypes
  description?: ReactNode | string
  iconProps?: Partial<IconOptions>
}

const Tickets: React.FC<TicketsProps> = ({
  backgroundImage = 'url(https://img.granted.co/1655736832539-concert-tickets.png)',
  title = 'Concert tickets',
  color = 'pink-real',
  icon = 'music',
  description = 'You can’t mosh from your couch. Choose your favorite artist or search their name above.',
  iconProps,
}) => (
  <Wrapper style={{ padding: 0 }}>
    <div
      className={styles['main-image']}
      style={{ '--background': backgroundImage } as CSSProperties}
    >
      <div className={styles.overlay} />
      <Grid className={styles['main-text']} filter="drop-shadow(0px 2px 1px black)">
        <Icon name={icon} width="4em" height="4em" glowColor={color} {...iconProps} />
        <GlowHeading Tag="h2" size="h1" color={color} uppercase>
          {title}
        </GlowHeading>
        {isValidElement(description) ? (
          description
        ) : (
          <Typography.Paragraph>{description}</Typography.Paragraph>
        )}
      </Grid>
    </div>
  </Wrapper>
)

export default Tickets
